
window.configureAnimatedEgiftPreview = function () {
    $('[data-animated-egift-preview-url]').off();
    $('[data-animated-egift-preview-url]').on('click', function () {
        var url = $(this).data('animated-egift-preview-url');
        var title = $(this).data('animated-egift-preview-popup-title');
        var autoplay = $(this).data('animated-egift-autoplay') === true;

        $('#modalAnimatedEgiftPreview').remove();

        const modalHtml = ModalTemplateHtml
            .replace('{{VIDEO_URL}}', url)
            .replace('{{VIDEO_URL}}', url)
            .replace('{{MODAL_TITLE}}', title);

        $('body').append(modalHtml);

        $('#modalAnimatedEgiftPreview').modal();

        if (url.endsWith('.gif')) {
            $('#modalAnimatedEgiftPreview .modal-body > video').remove();
        } else {
            $('#modalAnimatedEgiftPreview .modal-body > img').remove();

            if (autoplay) {
                $('#modalAnimatedEgiftPreview video')[0].play();
            }
        }

        $('#modalAnimatedEgiftPreview').on('hidden.bs.modal', function (e) {
            var video = $('#modalAnimatedEgiftPreview video')[0];

            if (video !== undefined) {
                video.pause();
                video.currentTime = 0;
            }
        });
    });
}

var ModalTemplateHtml =
    '<div id="modalAnimatedEgiftPreview" class="modal animated-egift-preview" tabindex="-1" role="dialog">' +
        '<div class="modal-dialog" role="document">' +
            '<div class="modal-content">' +
                '<div class="modal-header">' +
                    '{{MODAL_TITLE}}' +
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
                        '<span aria-hidden="true">&times;</span>' +
                    '</button>' +
                '</div>' +
                '<div class="modal-body">' +
                    '<video controls>' +
                        '<source src="{{VIDEO_URL}}" type="video/mp4">' +
                    '</video>' +
                    '<img src="{{VIDEO_URL}}" />' +
                '</div>' +
            '</div>' +
        '</div>' +
    '</div>';
